<pdq-tabs-group variant="underline" (onChange)="onTabChange($event)" [leftMargin]="'none'">
  @for (tab of tabs; track tab.value) {
    <pdq-tab [label]="tab.label" [value]="tab.value" [active]="tab.value === activeTab"></pdq-tab>
  }
</pdq-tabs-group>

<div class="discount-rejection-coupon">
  <div class="content">
    <form [formGroup]="formGroup">
      @switch (activeTab) {
        @case (DiscountRejectionCouponTab.SETTINGS) {
          <discount-rejection-coupon-settings [formGroup]="formGroup"></discount-rejection-coupon-settings>
        }
        @case (DiscountRejectionCouponTab.CONFIGURATIONS) {
          <discount-rejection-coupon-configuration
            [configurationsFormArray]="configurationsFormArray"
            [storeDiscountOptions]="storeDiscountOptions"
            [shopCurrencySymbol]="shopCurrencySymbol"
            (onAddConfiguration)="addConfiguration()"
            (onRemoveConfiguration)="removeConfiguration($event)"
            (onDuplicateConfiguration)="duplicateConfiguration($event)"
            (onSearchDiscount)="onSearchDiscount($event)">
          </discount-rejection-coupon-configuration>
        }
        @case (DiscountRejectionCouponTab.DISPLAY_CONDITIONS) {
          <discount-rejection-coupon-conditions
            [formGroup]="formGroup"
            [displayRules]="displayRules"
            [displayRulesEntities]="displayRulesEntities"
            [shopCurrencySymbol]="shopCurrencySymbol"></discount-rejection-coupon-conditions>
        }
        @case (DiscountRejectionCouponTab.APPEARANCE) {
          <discount-rejection-coupon-appearance
            [appearanceFormGroup]="appearanceFormGroup"
            [isClickableDisabled]="isClickableDisabled"></discount-rejection-coupon-appearance>
        }
      }
    </form>
  </div>
</div>
